import React from 'react';
import { Box, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const getParentColumns = ({ hasPermission, handleDelete, isLoading }) => [
    {
        header: 'Parent Name',
        render: (row) => `${row.user?.firstName || row.firstName || ''} ${row.user?.lastName || row.lastName || ''}`,
    },
    {
        header: 'Occupation',
        render: (row) => row.parentInfo?.occupation || 'N/A',
    },
    {
        header: 'Email',
        render: (row) => row.user?.email || row.email || 'N/A',
    },
    {
        header: 'Phone',
        render: (row) => row.user?.phoneNumber || row.phoneNumber || 'N/A',
    },
    {
        header: 'Actions',
        render: (row) => (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                {hasPermission('ADMIN', 'DELETE') && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(row.userId || row.user?.userId, row.email || row.user?.email);
                        }}
                        disabled={isLoading}
                    >
                        <DeleteIcon />
                    </IconButton>
                )}
            </Box>
        ),
    },
];
